import { render, staticRenderFns } from "./ArtworkList.vue?vue&type=template&id=f00da0aa&scoped=true&"
import script from "./ArtworkList.vue?vue&type=script&lang=js&"
export * from "./ArtworkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00da0aa",
  null
  
)

export default component.exports